module.exports = __webpack_public_path__ + "static/southern-hills-7a70f0ac31568b9e1ad1d572d963f185.png";